// write all keys in lowercase
export const presetFilterValuesLocales: Record<string, string> = {
  any: $localize`:PBasket|Preset any display name@@presetAnyDisplayName:All`,
  discount: $localize`:PBasket|Preset discount display name@@presetDiscountDisplayName:Discount`,
  future: $localize`:PBasket|Preset future display name@@presetFutureDisplayName:Future`,
  mynoos: $localize`:PBasket|Preset mynoos display name@@presetMynoosDisplayName:My NOOS`,
  marketing: $localize`:PBasket|Preset marketing display name@@presetMarketingDisplayName:Marketing`,
  new: $localize`:PBasket|Preset new display name@@presetNewDisplayName:New`,
  now: $localize`:PBasket|Preset now display name@@presetNowDisplayName:Now`,
  noos: $localize`:productBasket|Translation for noos materialgroup display name@@noosMaterialGroupDisplayName:Noos`,
  nos: $localize`:PBasket|Preset nos display name@@presetNosDisplayName:NOS`,
  sale: $localize`:PBasket|Preset sale display name@@presetSaleDisplayName:Sale`,
  musthave: $localize`:PBasket|Preset must have display name@@presetMustHaveDisplayName:Must Have`,
};

const menLabel = $localize`:PBasket|Gender men display name@@genderMenDisplayName:Men`;
const womenLabel = $localize`:PBasket|Gender women display name@@genderWomenDisplayName:Women`;
export const genderFilterValuesLocales: Record<string, string> = {
  men: menLabel,
  male: menLabel,
  mens: menLabel,
  women: womenLabel,
  womens: womenLabel,
  female: womenLabel,
};

export const categoryFilterValuesLocales: Record<string, string> = {
  clothing: $localize`:PBasket|Category clothing display name@@categoryClothingDisplayName:Clothing`,
  shoes: $localize`:PBasket|Category shoes display name@@categoryShoesDisplayName:Shoes`,
  accessories: $localize`:PBasket|Category accessories display name@@categoryAccessoriesDisplayName:Accessories`,
};

export const subCategoryFilterValuesLocales: Record<string, string> = {
  'big & tall': $localize`:PBasket|SubCategory big & tall display name@@subCategoryBigAndTallDisplayName:Big & Tall`,
  blazer: $localize`:PBasket|SubCategory blazer display name@@subCategoryBlazerDisplayName:Blazer`,
  blouses: $localize`:PBasket|SubCategory blouses display name@@subCategoryBlousesDisplayName:Blouses`,
  bodywear: $localize`:PBasket|SubCategory bodywear display name@@subCategoryBodywearDisplayName:Bodywear`,
  coats: $localize`:PBasket|SubCategory coats display name@@subCategoryCoatsDisplayName:Coats`,
  cardigans: $localize`:PBasket|SubCategory cardigans display name@@subCategoryCardigansDisplayName:Cardigans`,
  dresses: $localize`:PBasket|SubCategory dresses display name@@subCategoryDressesDisplayName:Dresses`,
  jackets: $localize`:PBasket|SubCategory jackets display name@@subCategoryJacketsDisplayName:Jackets`,
  'jumpsuits/overall': $localize`:PBasket|SubCategory jumpsuits/overall display name@@subCategoryJumpsuitsOverallDisplayName:Jumpsuits/Overall`,
  jeans: $localize`:PBasket|SubCategory jeans display name@@subCategoryJeansDisplayName:Jeans`,
  lingerie: $localize`:PBasket|SubCategory lingerie display name@@subCategoryLingerieDisplayName:Lingerie`,
  loungewear: $localize`:PBasket|SubCategory loungewear display name@@subCategoryLoungewearDisplayName:Loungewear`,
  overshirts: $localize`:PBasket|SubCategory overshirts display name@@subCategoryOvershirtsDisplayName:Overshirts`,
  polos: $localize`:PBasket|SubCategory polos display name@@subCategoryPolosDisplayName:Polos`,
  pullover: $localize`:PBasket|SubCategory pullover display name@@subCategoryPulloverDisplayName:Pullover`,
  shirts: $localize`:PBasket|SubCategory shirts display name@@subCategoryShirtsDisplayName:Shirts`,
  shorts: $localize`:PBasket|SubCategory shorts display name@@subCategoryShortsDisplayName:Shorts`,
  skirts: $localize`:PBasket|SubCategory skirts display name@@subCategorySkirtsDisplayName:Skirts`,
  socks: $localize`:PBasket|SubCategory socks display name@@subCategorySocksDisplayName:Socks`,
  suits: $localize`:PBasket|SubCategory suits display name@@subCategorySuitsDisplayName:Suits`,
  sweater: $localize`:PBasket|SubCategory sweater display name@@subCategorySweaterDisplayName:Sweater`,
  sweaters: $localize`:PBasket|SubCategory sweaters display name@@subCategorySweatersDisplayName:Sweaters`,
  swimwear: $localize`:PBasket|SubCategory swimwear display name@@subCategorySwimwearDisplayName:Swimwear`,
  't-shirts': $localize`:PBasket|SubCategory t-shirts display name@@subCategoryTShirtsDisplayName:T-Shirts`,
  trousers: $localize`:PBasket|SubCategory trousers display name@@subCategoryTrousersDisplayName:Trousers`,
  underwear: $localize`:PBasket|SubCategory underwear display name@@subCategoryUnderwearDisplayName:Underwear`,
  vests: $localize`:PBasket|SubCategory vests display name@@subCategoryVestsDisplayName:Vests`,
};

export const materialFilterValuesLocales: Record<string, string> = {
  angora: $localize`:PBasket|Material angora display name@@materialAngoraDisplayName:Angora`,
  cashmere: $localize`:PBasket|Material cashmere display name@@materialCashmereDisplayName:Cashmere`,
  cork: $localize`:PBasket|Material cork display name@@materialCorkDisplayName:Cork`,
  cotton: $localize`:PBasket|Material cotton display name@@materialCottonDisplayName:Cotton`,
  down: $localize`:PBasket|Material down display name@@materialDownDisplayName:Down`,
  jute: $localize`:PBasket|Material jute display name@@materialJuteDisplayName:Jute`,
  lambskin: $localize`:PBasket|Material lambskin display name@@materialLambskinDisplayName:Lambskin`,
  lambswool: $localize`:PBasket|Material lambswool display name@@materialLambswoolDisplayName:Lambswool`,
  leather: $localize`:PBasket|Material leather display name@@materialLeatherDisplayName:Leather`,
  linen: $localize`:PBasket|Material linen display name@@materialLinenDisplayName:Linen`,
  mohair: $localize`:PBasket|Material mohair display name@@materialMohairDisplayName:Mohair`,
  'new wool': $localize`:PBasket|Material new wool display name@@materialNewWoolDisplayName:New wool`,
  'organic cotton': $localize`:PBasket|Material organic cotton display name@@materialOrganicCottonDisplayName:Organic cotton`,
  polyester: $localize`:PBasket|Material polyester display name@@materialPolyesterDisplayName:Polyester`,
  rubber: $localize`:PBasket|Material rubber display name@@materialRubberDisplayName:Rubber`,
  silk: $localize`:PBasket|Material silk display name@@materialSilkDisplayName:Silk`,
  'synthetic leather': $localize`:PBasket|Material synthetic leather display name@@materialSyntheticLeatherDisplayName:Synthetic leather`,
  viscose: $localize`:PBasket|Material viscose display name@@materialViscoseDisplayName:Viscose`,
  'wool (alpaca wool)': $localize`:PBasket|Material alpaca wool display name@@materialAlpacaWoolDisplayName:Wool (alpaca wool)`,
  "wool (sheep's wool)": $localize`:PBasket|Material sheep wool display name@@materialSheepWoolDisplayName:Wool (sheep's wool)`,
};

export const colorFilterValuesLocales: Record<string, string> = {
  beige: $localize`:PBasket|Color filter beige display name@@colorFilterBeigeDisplayName:beige`,
  black: $localize`:PBasket|Color filter black display name@@colorFilterBlackDisplayName:black`,
  blue: $localize`:PBasket|Color filter blue display name@@colorFilterBlueDisplayName:blue`,
  bronze: $localize`:PBasket|Color filter bronze display name@@colorFilterBronzeDisplayName:bronze`,
  brown: $localize`:PBasket|Color filter brown display name@@colorFilterBrownDisplayName:brown`,
  combo: $localize`:PBasket|Color filter combo display name@@colorFilterComboDisplayName:combo`,
  denim: $localize`:PBasket|Color filter denim display name@@colorFilterDenimDisplayName:denim`,
  gold: $localize`:PBasket|Color filter gold display name@@colorFilterGoldDisplayName:gold`,
  green: $localize`:PBasket|Color filter green display name@@colorFilterGreenDisplayName:green`,
  gray: $localize`:PBasket|Color filter gray display name@@colorFilterGrayDisplayName:gray`,
  grey: $localize`:PBasket|Color filter grey display name@@colorFilterGreyDisplayName:grey`,
  metallic: $localize`:PBasket|Color filter metallic display name@@colorFilterMetallicDisplayName:metallic`,
  metal: $localize`:PBasket|Color filter metal display name@@colorFilterMetalDisplayName:metal`,
  none: $localize`:PBasket|Color filter none display name@@colorFilterNoneDisplayName:none`,
  orange: $localize`:PBasket|Color filter orange display name@@colorFilterOrangeDisplayName:orange`,
  pink: $localize`:PBasket|Color filter pink display name@@colorFilterPinkDisplayName:pink`,
  purple: $localize`:PBasket|Color filter purple display name@@colorFilterPurpleDisplayName:purple`,
  rainbow: $localize`:PBasket|Color filter rainbow display name@@colorFilterRainbowDisplayName:rainbow`,
  red: $localize`:PBasket|Color filter red display name@@colorFilterRedDisplayName:red`,
  rose: $localize`:PBasket|Color filter rose display name@@colorFilterRoseDisplayName:rose`,
  silver: $localize`:PBasket|Color filter silver display name@@colorFilterSilverDisplayName:silver`,
  turquoise: $localize`:PBasket|Color filter turquoise display name@@colorFilterTurquoiseDisplayName:turquoise`,
  violet: $localize`:PBasket|Color filter violet display name@@colorFilterVioletDisplayName:violet`,
  white: $localize`:PBasket|Color filter white display name@@colorFilterWhiteDisplayName:white`,
  yellow: $localize`:PBasket|Color filter yellow display name@@colorFilterYellowDisplayName:yellow`,
  unspecified: $localize`:PBasket|Color filter unspecified display name@@colorFilterUnspecifiedDisplayName:unspecified`,
};

export const fitFilterValuesLocales: Record<string, string> = {
  boyfriend: $localize`:PBasket|Fit boyfriend display name@@fitBoyfriendDisplayName:Boyfriend`,
  bootcut: $localize`:PBasket|Fit bootcut display name@@fitBootcutDisplayName:Bootcut`,
  cropped: $localize`:PBasket|Fit cropped display name@@fitCroppedDisplayName:Cropped`,
  fitted: $localize`:PBasket|Fit fitted display name@@fitFittedDisplayName:Fitted`,
  flared: $localize`:PBasket|Fit flared display name@@fitFlaredDisplayName:Flared`,
  loose: $localize`:PBasket|Fit loose display name@@fitLooseDisplayName:Loose`,
  oversized: $localize`:PBasket|Fit oversized display name@@fitOversizedDisplayName:Oversized`,
  overshirt: $localize`:PBasket|Fit overshirt display name@@fitOvershirtDisplayName:Overshirt`,
  regular: $localize`:PBasket|Fit regular display name@@fitRegularDisplayName:Regular`,
  relaxed: $localize`:PBasket|Fit relaxed display name@@fitRelaxedDisplayName:Relaxed`,
  shaped: $localize`:PBasket|Fit shaped display name@@fitShapedDisplayName:Shaped`,
  skinny: $localize`:PBasket|Fit skinny display name@@fitSkinnyDisplayName:Skinny`,
  slim: $localize`:PBasket|Fit slim display name@@fitSlimDisplayName:Slim`,
  straight: $localize`:PBasket|Fit straight display name@@fitStraightDisplayName:Straight`,
  tapered: $localize`:PBasket|Fit tapered display name@@fitTaperedDisplayName:Tapered`,
  wide: $localize`:PBasket|Fit wide display name@@fitWideDisplayName:Wide`,
};

const hasMarketingSupportValueLabel = $localize`:productBasket|Translation for has marketing support@@hasMarketingSupportFilterValue:Has marketing support`;
// write all keys in lowercase, use getFilterValueLabel to gel label
export const filterValuesLocales: Record<string, string> = {
  ...presetFilterValuesLocales,
  ...genderFilterValuesLocales,
  ...categoryFilterValuesLocales,
  ...subCategoryFilterValuesLocales,
  ...materialFilterValuesLocales,
  ...fitFilterValuesLocales,
  hasmarketingsupport: hasMarketingSupportValueLabel,
  flash: $localize`:productBasket|Translation for flash materialgroup display name@@flashMaterialGroupDisplayName:Flash`,
  mainline: $localize`:productBasket|Translation for mainline materialgroup display name@@mainlineMaterialGroupDisplayName:Mainline`,
  ...colorFilterValuesLocales,
};

export const getFilterValueLabel = (value: string): string | undefined => {
  return filterValuesLocales[value?.toLowerCase()];
};
